<template>
  <div>
    <section class="subpage-head">
      <div class="container">
        <h1>Register</h1>
        <!--<a href="" class="shtool">Manage my profile</a>-->
      </div>
    </section>
    
    
    <section class="login-reg">
      <div class="container">
        <div class="log-box main">
          <form class="gen-form" v-on:submit.prevent="doRegister">
            <div class="form-row split">
              <div>
                <label>First name:</label>
                <input type="text" v-model="register.firstname" required />
              </div>
              <div>
                <label>Last name:</label>
                <input type="text" v-model="register.lastname" required />
              </div>
            </div>
            <div class="form-row">
              <label>Email:</label>
              <input type="email" v-model="register.username" required />
            </div>
            <div class="form-row">
              <label>Password:</label>
              <input type="password" v-model="register.password" required />
            </div>
            <div class="form-row">
              <label>Confirm password:</label>
              <input type="password" v-model="register.password2" required />
            </div>
            <div class="form-row split">
              <label class="checkbox">
                <input type="checkbox" v-model="register.agreed" />
                <em></em>
                <span>I agree to <a href="" target="_blank" v-on:click.prevent="showTc">terms and conditions</a></span>
              </label>
            </div>
            <div class="form-act">
              <button class="lbtn">Register</button>
            </div>
          </form>
        </div>
        <div class="log-box sec existing-account">
          <div class="exi-title">Great to see you back online for more learning</div>
          <div class="exi-subtitle">Have you already created your account?</div>
<!--           <div class="reg-title">Already have an account?</div> -->
          <!--<ul class="reg-list">
            <li>individual video</li>
            <li>Private Videos</li>
            <li>Videos per group</li>
            <li>Questionare</li>
            <li>and more</li>
          </ul>
          <div class="reg-act">Join now!</div>-->
          <div class="form-act">
            <router-link :to="{name: 'user.login'}" class="lbtn">Login</router-link>
          </div>
        </div>
      </div>
    </section>
  
  </div>
</template>
<script>
import api from './api';
export default {
  data: ()=>({
    expiryPeriodPercent: 25,
    username: "",
    password: "",
    rememberme: false,
    register: {currency: "USD"},
  }),
  methods: {
    showTc() {
      appRoot.tcVisible=true;
    },
    async doRegister() {
      if (!this.register.agreed)
        return appNotifications.show("You have to agree to the terms and conditions", "error");
      var result=await api.register(this.register);
      if (result.success) {
        appNotifications.show("You have successfully registered", "success");
        window.userData={
          username: this.register.username,
          password: this.register.password,
        };
        this.$router.push("/user/login");
      } else {
        appNotifications.show(result.error, "error");
      }
    }
  },
  async created() {
  },
}
</script>
